
/**
 * @nullable
 */
export type CourseResponseLevel = typeof CourseResponseLevel[keyof typeof CourseResponseLevel] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CourseResponseLevel = {
  BEGINNER: 'BEGINNER',
  INTERMEDIATE: 'INTERMEDIATE',
  ADVANCED: 'ADVANCED',
  ALL: 'ALL',
} as const;
